
export const userQuery = {
  query: `query User($email: String) {
      user(email: $email) {
        _id
        email
        phone
        permissions { name, status }
        userStatus {
          trialState
          isTrial
          trialDaysLeft
          isRegistered
          isOnCompany
        }
        productRequests
        trialExtensionRequested
        createdOn
        acceptedLatestTos
        mc_number
        dot_number
      }
    }`,
};

export const updateUser = {
  query: `mutation UpdateUser($user: UserInput, $changed: ChangedUser) {
    updateUser(user: $user, changed: $changed) {
        _id,
        email,
        firstname,
        lastname,
        phone,
        company,
        productRequests,
        pfjMyRewardsNumber
    }
  }`,
};

export const updateTrialUser = {
  query: `mutation  UpdateTrialUser($email: String, $changed: ChangedTrialUser) {
    updateTrialUser(email: $email, changed: $changed) {
        _id,
        productRequests,
        trialExtensionRequested,
    }
  }`,
};

export const acceptTermsAndConditions = {
  query: `mutation AcceptTermsAndConditions($email: String, $terms: TermsOfUseInput) {
    setAcceptedTermsAndConditions(email: $email, terms: $terms) {
      _id,
      email,
      acceptedLatestTos
    }
  }`,
};
